import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@guildeducationinc/recess';
import { useEffect, useMemo } from 'react';
// Map status codes to English labels (Weglot will translate these)
const STATUS_LABELS = {
    covered: 'Covered',
    cancelled: 'Cancelled',
    closed: 'Closed',
    info_needed: 'Info needed',
    in_review: 'In-review',
    not_covered: 'Not covered',
    not_yet_submitted: 'Not yet submitted',
    approved: 'Sent to employer',
    awaiting_documents: 'Awaiting documents',
    denied: 'Denied',
    expired: 'Expired',
    needs_correction: 'Needs correction',
    ready_for_payment: 'Approved',
};
const PROGRAM_STATUSES = new Set([
    'covered',
    'cancelled',
    'closed',
    'info_needed',
    'in_review',
    'not_covered',
]);
const PAYMENT_REQUEST_STATUSES = new Set([
    'in_review',
    'not_yet_submitted',
    'approved',
    'awaiting_documents',
    'denied',
    'expired',
    'needs_correction',
    'ready_for_payment',
]);
export const ActivityStatusPicker = ({ value, onChange, statusContext, }) => {
    const options = useMemo(() => {
        const allowedStatuses = statusContext === 'program'
            ? PROGRAM_STATUSES
            : statusContext === 'payment_request' || statusContext === 'budget_approval'
                ? PAYMENT_REQUEST_STATUSES
                : null;
        const labelOverrides = statusContext === 'budget_approval' ? { not_yet_submitted: 'Funds approved' } : {};
        const filtered = Object.entries(STATUS_LABELS)
            .filter(([status]) => !allowedStatuses || allowedStatuses.has(status))
            .map(([status, label]) => ({ value: status, label: labelOverrides[status] ?? label }))
            .sort((a, b) => a.label.localeCompare(b.label));
        return [{ value: '', label: 'All statuses' }].concat(filtered);
    }, [statusContext]);
    // Clear selected value if it's no longer valid for the current context
    useEffect(() => {
        if (value && statusContext) {
            const allowedStatuses = statusContext === 'program' ? PROGRAM_STATUSES : PAYMENT_REQUEST_STATUSES; // covers 'payment_request' and 'budget_approval'
            if (!allowedStatuses.has(value)) {
                onChange('');
            }
        }
    }, [statusContext, value, onChange]);
    const handleChange = (e) => {
        if (e.target.value) {
            onChange(e.target.value);
        }
        else {
            onChange('');
        }
    };
    return (_jsx(Select, { label: 'Status', options: options, placeholder: 'All statuses', isSearchable: false, value: value, onChange: handleChange, isClearable: false }));
};
